<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <label class="text-red-500">*</label> são obrigatórios
              </p>
            </div>

            <div class="lg:col-span-2">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">
                
                <!-- doc type -->
                <div class="md:col-span-2">
                  <div class="md:col-span-2 mt-1.5">
                    <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.period">
                      Periodo <a class="text-red-600 ml-1">*</a>
                    </label>
                    <div
                      class="h-10 flex rounded items-center"
                    >
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="dates"
                        :initialValue="store.form?.period"
                        @selected-data="(val) => (store.form.period = val.name)"
                      />
                    </div>
                  </div>

                  <span
                    name="form.period"
                    class="text-red-600 text-sm"
                  />
                </div>

                <div class="md:col-span-2">
                  <div class="md:col-span-2 mt-1.5">
                    <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
                      Tipo
                    </label>
                    <div
                      class="h-10 flex rounded items-center"
                    >
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="ponto"
                        :initialValue="store.form?.pontoType"
                        @selected-data="(val) => (store.form.pontoType = val.name)"
                      />
                    </div>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div 
                      v-if="store.form?.period == 'PERSONALIZADO'" 
                      class="grid gap-2 gap-y-2 text-sm grid-cols-1 md:grid-cols-2"
                    >
                      <!-- date_start  -->
                      <div class="md:col-span-1">
                        <BaseInput
                          type="date"
                          name="store.form.date_start"
                          v-model="store.form.date_start"
                          :info="'Data inicial'"
                          label="Data"
                          :required-field="true"
                          :activeDefault="true"
                        >
                          <template #append>
                            <CleanInputButton @click="store.form.date_start = null" />
                          </template>
                        </BaseInput>
                      </div>
    
                      <!-- date_end -->
                      <div class="md:col-span-1">
                        <BaseInput
                          type="date"
                          name="store.form.date_end"
                          v-model="store.form.date_end"
                          :info="'Data Final'"
                          label="Data"
                          :required-field="true"
                          :activeDefault="true"
                        >
                          <template #append>
                            <CleanInputButton @click="store.form.date_end = null" />
                          </template>
                        </BaseInput>
                      </div>
                    </div>
                  </Transition>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-center mt-8">
            <slot />
          </div>

        </div>
      </div>
    </div>
    <!-- <FloatBackPage /> -->
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../components/CleanInputButton.vue';
import BaseInput from '@/components/Inputs/BaseInput.vue';
import { PhCloudArrowUp, PhCloudCheck, PhFileArrowUp } from '@phosphor-icons/vue';
import { dates, ponto } from '../lookups/form';
import { dataHome } from '../store'

export default({
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
  },
  props: {
    descriptionTitle: String,
  },
  data () {
    return {
      PhFileArrowUp,
      PhCloudArrowUp,
      PhCloudCheck,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataHome.state,
      dataHome,
      dates,
      ponto
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        this.selectedFileName = file.name
        this.selectedFileUrl = URL.createObjectURL(file)
        
        this.store.form.docName = this.selectedFileName
        this.store.form.doc = file
      }
    }
  }
})
</script>
